import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import TechniquesSection from './TechniquesSection';

const Module = () => {
  const packages = [
    { title: 'Choose 4 Recipes at', price: 'Rs. 4000' },
    { title: 'Choose 6 Recipes at', price: 'Rs. 5500' },
    { title: 'Choose 10 Recipes at', price: 'Rs. 8,000' },
  ];

  const categories = [
    {
      title: 'Muffins',
      img: '/images/muffin.webp',
      items: [
        'Chocolate chip muffin',
        'Vanilla berry',
        'Oats & Cherry',
        'Coconut',
        'Apple & Cinnamon',
        'Savoury muffin',
      ],
    },
    {
      title: 'Cupcakes',
      img: '/images/cup.webp',
      items: [
        'Chocolate Cupcake',
        'Red velvet cupcake',
        'Vanilla coffee',
        ' Carrot & Walnut',
        ' Banana caramel cupcake',
        
      ],
    },
    {
    title: 'Sweet tarts',
    img: '/images/sweettartout.jpg',
    items: [
      'Chocolate custard tart',
      'Lemon meringue tart',
      'Fruit tart',
      'Bakewell tart',
      'Apple pie',
    ],
  },
  {
    title: 'Savory bakes',
    img: '/images/savor.jpg',
    items: [
      'Korean cheese bun',
      'Chicken sausage quiche',
      'Creamy mushroom tart',
      'Stromboli',
      'Pizza',
    ],
  },
  {
    title: 'Cheesecakes',
    img: '/images/cheese.webp',
    items: [
      'Newyork cheese',
      'Chocolate basque cheesecake',
      'Japanese cheesecake',
      'No Bake cold cheesecake',
    ],
  },
  {
    title: 'Eggless bakes',
    img: '/images/egg.webp',
    items: [
      'Chocolate chunk cookies',
      'Coconut lime tart',
      'Dark chocolate cupcake',
      'Vanilla pound cake',
      'Blondie',
    ],
  },
  {
    title: 'Choux pastry',
    img: '/images/choux.webp',
    items: [
      'Chocolate eclair',
      'Lemon meringue eclair',
      'Red berry Profiteroles',
      'Paris brest',
      'Hazelnut Profiteroles',
      'Caramel religieuse',
    ],
  },
  {
    title: 'Cookies and Macarons',
    img: '/images/cookies.jpg',
    items: [
      'Chocolate chip cookies',
      'Danish butter cookies',
      'Thumbprint Cookies',
      'Piping cookies',
      'Brownie',
      'Oats & Raisin cookies',
      'Salt Cookies',
      'Biscotti',
      'Lime shortbread',
      'Italian meringue macaron',
      'French meringue macaron',
    ],
  },
  {
    title: 'Travel cakes',
    img: '/images/travel.webp',
    items: [
      'Classic marble cake',
      'Dark chocolate loaf',
      'Lemon cake',
      'Carrot cake',
      'Pineapple upside down',
    ],
  },
  {
    title: 'Breads & Viennoiseries',
    img: '/images/vienno.webp',
    items: [
      'Burger bun',
      'Brioche',
      'Hot cross bun',
      'Japanese Milk bread',
      'Sandwich loaf',
      'Sourdough loaf with Biga starter',
      'Cinnamon roll',
      'Doughnut',
      'Apple turnover puff',
      'Ciabatta',
      'Focaccia',
      'Butter croissant',
      'Almond croissant',
      'Pain au chocolat',
      'Chocolat babka',
    ],
  },
  {
    title: 'Classic Desserts',
    img: '/images/dess.webp',
    items: [
      'Tiramisu',
      'Basque cheesecake',
      'French Opera',
      'Crème caramel',
      'Yule log',
      'Berry panna cotta',
      'Pavlova',
      'Chocolate mousse entremet',
    ],
  },
  ];

  return (
    <>
    <div style={{ backgroundColor: '#f8f8f8', padding: '40px 0' }}>
      <Container>
        {/* Heading */}
        <h2 className="text-center fw-bold mb-4" style={{ color: '#b23a30' }}>
          Customized Module
        </h2>

        {/* Pricing Boxes */}
        <Row className="justify-content-center mb-5 text-center">
          {packages.map((pkg, index) => (
            <Col key={index} xs={12} sm={6} md={3} className="mb-3">
              <Card
                className="h-100"
                style={{
                 
                  borderRadius: '15px',
                  padding: '35px',
                  backgroundColor: '#fff',
                }}
              >
                <Card.Body>
                  <Card.Title className="fw-bold" style={{ color: '#b23a30',fontSize: '20px' }}>
                    {pkg.title}
                  </Card.Title>
                  <Card.Text className="fw-bold" style={{ fontSize: '20px' }}>
                    {pkg.price}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
         </Container>
 </div>
        {/* Category Grid */}
        <Container className="pt-5">
        <Row>
          {categories.map((cat, index) => (
            <Col key={index} xs={12} md={6} lg={4} className="mb-4">
              <Card
                className="h-100 text-center"
                style={{
                 
                  border: 'none',
                }}
              >
                {cat.img && (
                  <Card.Img
                    variant="top"
                    src={cat.img}
                    alt={cat.title}
                    style={{
                        width: '100%',
                      
                      objectFit: 'cover',
                       border: '2px solid #d5a092',
                      borderTopLeftRadius: '10px',
                      borderTopRightRadius: '10px',
                    }}
                  />
                )}
                <Card.Body>
                  <Card.Title
                    className="fw-bold mb-3 mt-3"
                    style={{ color: '#b23a30', fontSize: '24px', }}
                  >
                    {cat.title}
                  </Card.Title>
                  <ul className="text-start" style={{ color: '#000', paddingLeft: '12%' }}>
                    {cat.items.map((item, idx) => (
                      <li key={idx} style={{ fontSize: '0.95rem', marginBottom: '5px' }}>
                        {item}
                      </li>
                    ))}
                  </ul>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
      <TechniquesSection/>
   
    </>
  );
};

export default Module;
